<template>
  <div>
    <router-link :to="path">{{ name }}</router-link>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'AppButton',
  props: {
    path: String,
    name: String
  }
}
</script>

<style scoped lang="scss">
$transitionSpeed: .5s;

div {
  width: 100%;

  a {
    position: relative;
    display: block;
    padding: 21px 0;
    font-size: 12px;
    font-weight: bold;
    text-align: center;
    color: inherit;
    background: #fff;
    border: 1px solid #9b9b9b;
    cursor: pointer;
    transition: $fastTransition;

    @include mq(tb) {
      padding: 16px 0;
    }

    &::before {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      content: '';
      width: 0;
      height: 0;
      border: 1px solid transparent;
    }

    &::after {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      content: '';
      width: 0;
      height: 0;
      border: 1px solid transparent;
    }

    &:hover {
      &::before {
        width: 100%;
        height: 100%;
        border-top-color: #000;
        border-right-color: #000;
        transition: width $transitionSpeed, height $transitionSpeed $transitionSpeed;
      }

      &::after {
        width: 100%;
        height: 100%;
        border-bottom-color: #000;
        border-left-color: #000;
        transition: height $transitionSpeed, width $transitionSpeed $transitionSpeed;
      }
    }
  }
}
</style>
